import React from 'react';
import PropTypes from 'prop-types';
import { Paper, TextField } from 'material-ui';
import EmojiPicker from 'dash-front/campaign/components/Form/pickers/EmojiPicker';
import _ from 'lodash';
import { addInputText } from 'dash-front/inputs';
import { TypeCascade } from './TypeCascade';
import { OddsPicker } from './OddsPicker';

export default class MessageBuilder extends React.PureComponent {
    assignRef = el => {
        if (el) {
            if (el.input instanceof Node) {
                this.input = el.input;
            } else {
                this.input = el.input.refs.input;
            }
            this.addText = addInputText(this.input, this.props.onChange);
        }
    };

    addProperty = property => {
        this.addText(this.props.value)('${' + property + '}');
    };

    renderTypes() {
        const { types } = this.props;
        if (Array.isArray(types) && types.length) {
            return types.map(el => (
                <Paper
                    key={el.name}
                    style={{
                        display: 'inline-block',
                        marginRight: 20
                    }}
                >
                    <TypeCascade type={el.type} name={el.name} label={el.label} onClick={this.addProperty} />
                </Paper>
            ));
        }
        return null;
    }

    renderOdds() {
        return this.props.withOdds ? (
            <OddsPicker
                style={{
                    margin: '0 20px 0 0'
                }}
                onAdd={this.addProperty}
            />
        ) : null;
    }

    onChange = (e, value) => {
        this.props.onChange(value);
    };

    render() {
        const props = _.omit(this.props, Object.keys(MessageBuilder.propTypes));
        return (
            <div>
                <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 15 }}>
                    {this.renderTypes()}
                    {this.renderOdds()}
                </div>
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <TextField {...props} multiLine ref={this.assignRef} fullWidth />
                    <EmojiPicker {...props} onChange={this.onChange} inputRef={this.input} />
                </div>
            </div>
        );
    }
}

MessageBuilder.propTypes = {
    types: PropTypes.array,
    withOdds: PropTypes.bool
};

export class RMessageBuilder extends React.PureComponent {
    render() {
        const userProps = _.omit(this.props, Object.keys(RMessageBuilder.propTypes));
        const error = this.props.meta.touched ? this.props.meta.error : undefined;
        return <MessageBuilder {...userProps} {...this.props.input} errorText={error} />;
    }
}

RMessageBuilder.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/messages/components/MessageBuilder.js
 **/